module.exports = __webpack_public_path__ + "static/media/kr_phone.5de6ca73.png";